import { render, staticRenderFns } from "./DevPurchArch.vue?vue&type=template&id=24fe04f6&scoped=true"
import script from "./DevPurchArch.vue?vue&type=script&lang=js"
export * from "./DevPurchArch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fe04f6",
  null
  
)

export default component.exports